import React from "react";
import injectSheet from "react-jss";

const BottomNavHome = (props) => {
  const { classes } = props;

  return (
    <div className={`${classes.navContainer}`}>
      <div className={`${classes.textContainer}`}>
        <div>
          <div className={`${classes.contactContainer}`}>
            <h3 className={`${classes.title}`}>Fragen?</h3>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "column",
              }}
            >
              <p className={`${classes.contactParagraph}`}>
                Schreiben Sie eine E-Mail an{" "}
                <a
                  href="mailto:info@hausconcept.ch"
                  className={`${classes.contactLink}`}
                >
                  {"info@hausconcept.ch "}
                </a>
                Oder rufen Sie uns unter{" "}
                <a href="tel:+41419222055" className={`${classes.contactLink}`}>
                  041 922 20 55
                </a>{" "}
                an
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = (theme) => ({
  title: {
    fontSize: "0.625rem",
    [theme.media.medium]: {
      fontSize: "1rem",
    },
    color: theme.colors.main_1,
  },
  contactContainer: {
    display: "flex",
    alignItems: "center",
    gap: "0.25rem",
  },
  contactLink: {
    color: theme.colors.main_1,
    textDecoration: "none",
    "&:hover": {
      color: theme.colors.main_3,
    },
  },
  contactParagraph: {
    fontSize: "0.625rem",
    [theme.media.medium]: {
      fontSize: "1rem",
    },
  },
  navContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    height: "100%",
    fontSize: "60%",
    [theme.media.medium]: {
      fontSize: "100%",
    },
  },
  textContainer: {
    width: "100%",
    padding: `0 ${theme.sizes.gutter / 2}px`,
    color: theme.colors.main_3,
  },
});

export default injectSheet(styles)(BottomNavHome);



// WEBPACK FOOTER //
// ./src/modules/core/components/bottomNavHome.jsx